var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0401 4.96856C14.7281 4.65656 14.2241 4.65656 13.9121 4.96856L10.0001 8.87256L6.08807 4.96056C5.77607 4.64856 5.27207 4.64856 4.96007 4.96056C4.64807 5.27256 4.64807 5.77656 4.96007 6.08856L8.87208 10.0006L4.96007 13.9126C4.64807 14.2246 4.64807 14.7286 4.96007 15.0406C5.27207 15.3526 5.77607 15.3526 6.08807 15.0406L10.0001 11.1286L13.9121 15.0406C14.2241 15.3526 14.7281 15.3526 15.0401 15.0406C15.3521 14.7286 15.3521 14.2246 15.0401 13.9126L11.1281 10.0006L15.0401 6.08856C15.3441 5.78456 15.3441 5.27256 15.0401 4.96856Z",
    fill: "#223E7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.470e3a73c1f83c044ffdab1aa82ff819.svg";
export { ForwardRef as ReactComponent };